module.exports = __webpack_public_path__ + "static/Events-59beaab68cd9fba401f2a669f7a274ac.png";